module.exports = __webpack_public_path__ + "static/media/RP-45.b9c64bf6.pdf";